import {GET, POST} from "@/services/gateway";

const listRestores = ({pagination, sourceType, dataTypes, dataProvider = 'BOX'}) => {
  return POST('recovery/restore/list', {pagination, sourceType, dataTypes, dataProvider})
}

const cancelRestore = (id) => {
  return GET(`box/drive/restore/${id}/cancel`)
}

export {
  listRestores,
  cancelRestore,
}
